<template>
  <div>
    <template v-if="translate && show">
      <div @dblclick="editCurrent">
        {{ translate.title ? translate.title : translate.value }}
      </div>
    </template>
    <template v-else style="display:flex; justify-content: between;">
      <input
        :disabled="state === 'P'"
        @keyup="newTitleDebounced"
        v-model="title"
        type="text"
        class="form-input"
        style="display:inline;"
        placeholder="здесь нужен перевод">
      <template v-if="title !== '' && state === 'A'">
        <a
          class="btn btn-success"
          @click="sendChange"
          style="padding:5px; margin-left: 10px;">
          <img
            src="@/assets/icons/check-solid.svg"
            width="10px"
            height="10px">
        </a>
        <a
          v-if="isUz()"
          class="btn btn-success"
          @click="translateTitle"
          style="padding:5px; margin-left: 10px;">
          <img
            src="@/assets/icons/language-solid.svg"
            width="10px"
            height="10px">
        </a>
      </template>
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import _debounce from 'lodash.debounce';

export default {
  name: "inputField",
  props: [
    "translate",
    "locale",
    "translate_code",
    "translate_id",
    "state",
    "change"
  ],
  data() {
      return {
        title: '',
        show: true
      };
  },
  computed: {
    newTitleDebounced() {
      return _debounce(this.newTitle, 700);
    },
  },
  watch:{
    change: {
      handler(val){
        // do stuff
        if(val) {
          if(typeof val.title === 'string')
          {
            this.title = val.title;
            if(typeof val.code === 'undefined'){
              this.show = true;
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    isUz() {
      return ['uz-Cyrl', 'uz-Latn'].includes(this.locale);
    },
    editCurrent() {
      this.show = false;
      this.title = this.translate.title;
    },
    translateTitle(){
      this.newTitle(true);
    },
    newTitle(translate = false) {
      this.title = this.title.trim();
      if(this.title !== '') {
        this.$emit('changed', {
          title: this.title,
          locale: this.locale,
          code: this.translate_code,
          id: this.translate_id,
          translate: translate,
        });
      }
    },
    sendChange() {
      this.$emit('sendChange', {
        locale: this.locale,
        id: this.translate_id
      })
      this.show = true;
    }
  }
};
</script>

